import { createContext } from 'react';

import { WeakMapSeries, HistogramSeries } from '../types/histogram.js';

export interface HistogramData {
  series: HistogramSeries[];
  seriesMap: WeakMapSeries;
  yUnits: HistogramSeries['unit'][];
}

export const HistogramDataContext = createContext<HistogramData>({
  series: [],
  seriesMap: new WeakMap(),
  yUnits: [],
});

HistogramDataContext['displayName'] = 'HistogramDataContext';
